<template>
    <v-container class="q-price-lookup">
        <!--access overlay-->
        <v-overlay color="#46c3b2" :value="!hasAccessCode()" class="text-center">
            <q-access-code></q-access-code>
        </v-overlay>
        <v-row>
            <!--
            <v-col cols="12" sm="4">
                <p>Enter you zip code</p>
                <v-text-field outlined v-model="ZipCode" :rules="[rules.required]" label="ZipCode" persistent-hint></v-text-field>
            </v-col>
        -->
            <v-col cols="12" sm="6" class="">
                <q-drug-lookup ref="QDrugLookup" label="Drug Name" v-model="DrugName" :placeholder="DrugName"></q-drug-lookup><br>
                <p class="">Common Searches</p>
                <q-popular-drugs v-model="DrugName"></q-popular-drugs>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="drug_update_form">
                <div>
                    <q-drug-components v-model="Pharmacies" :drug-name="DrugName" :zipcode.sync="ZipCode" v-on:results="updateResults"></q-drug-components>
                </div>
            </v-col>
            <v-col cols="12" sm="8" class="text-right mr-0 pr-0" v-if="show_map">
                <v-card>
                    <q-map ref="QMap" :pharmacies="Pharmacies" v-on:openpanel="updatePharmacyPanel"></q-map>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" class="ml-0 ml-0">
                <v-expansion-panels v-model="pharmacy_panel" class="pharmacy-panel" flat>
                    <v-expansion-panel v-for="(pharmacy, k) in Pharmacies" :key="k" style="border-top:1px solid #46c3b2">
                        <v-expansion-panel-header :color="pharmacy_panel == k ? '#f2fbf9' : 'white'">
                            <div class="price pr-5" style="min-width: 65px;">{{formatShortCurrency(pharmacy.Price)}}</div>
                            <div class=" pharmacy-name pr-5"><span class="med">{{pharmacy.PharmacyName}}</span> <br /><span class="light">{{pharmacy.Distance}} away</span></div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon size="18px" color="#005851">fas fa-map-marker-alt</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <a :href="'https://www.google.com/maps/dir/?api=1&destination=' + pharmacy.Lat + ',' + pharmacy.Long" target="_blank">{{pharmacy.Address}}</a>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon size="18px" color="#005851">fas fa-phone</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <a :href="'tel:' + pharmacy.PBMPhone" target="_blank">{{pharmacy.PBMPhone}}</a>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-btn color="#46c3b2" depressed dark @click="savePharmacy(pharmacy)" class="mt-6">
                                Add to Card
                            </v-btn>
                            <v-btn depressed text color="#46c3b2" class="ml-3 mt-6" href="/my-card/">
                                View Card
                            </v-btn>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <div v-if="Pharmacies.length>0">
                    <v-checkbox color="#46c3b2" v-model="show_map" label="Show On Map"></v-checkbox>
                </div>
            </v-col>
        </v-row>
        <v-snackbar color="primary" top :timeout="6000" v-model="snackbar">
            {{ snackbar_text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>
<script>
/**

An example form that basically has all the features.
You can use this as a mix in or as an extends to create new forms... changing the template to match.

**/
import QDrugLookup from '@/components/q-drug-lookup.vue'
import QDrugComponents from '@/components/q-drug-components.vue'
import QPopularDrugs from '@/components/q-popular-drugs.vue'
var numeral = require('numeral');
import QMap from '@/components/q-map.vue'
import { gmapApi } from 'vue2-google-maps'
import Cookies from 'js-cookie'
import QAccessCode from '@/components/q-access-code.vue'

export default {
    props: [], //used for development only - so we don't have to click a button.
    data: function() {
        return {
            snackbar_text: null,
            snackbar: false,
            DrugName: null,
            ZipCode: null,
            Pharmacies: [],
            pharmacy_panel: 0,
            show_map: true,
            rules: {
                'required': v => !!v || 'Required',
                'email': v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                'zip': v => Number.isInteger(Number(v)) && Number(v) < 99999 && (v !== null && v.length == 5) || 'Enter a valid zipcode',
                'date': v => moment(v, 'MM-DD-YYYY').isValid() || 'Enter a valid birth date',
                'phone': v => (Number.isInteger(Number(v)) && v.length == 10) || 'Please enter a valid phone number in the phone field.',
            },
        }
    },
    mounted: function() {
        var z = Cookies.get('QuilityRxZipCode');
        var g = this
        if (typeof z == 'undefined' || z == '') {
            setTimeout(this.getCurrentZipcode, 500)
        } else {
            setTimeout(function() {
                g.ZipCode = z
                g.centerOnZipCode(z)
            }, 250)
        }
    },
    methods: {
        updateResults: function(results) {
            results.sort((a, b) => (a.Price > b.Price) ? 1 : (a.Price === b.Price) ? ((a.Distance > b.Distance) ? 1 : -1) : -1 )
            this.Pharmacies = results
        },
        formatShortCurrency(n) {
            return numeral(n).format('($0[.]00)');
        },
        formatPercentage(n) {
            return numeral(n).format('($0[.]00)');
        },
        updateZipCode: function(z) {
            if (this.ZipCode == null) {
                this.ZipCode = z;
            }
        },
        updatePharmacyPanel(ix) {
            this.pharmacy_panel = ix
        },
        centerOnZipCode: function(zip) {
            var g = this
            if (g.google == null) {
                return
            }
            new g.google.maps.Geocoder().geocode({ 'address': zip }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var lat = results[0].geometry.location.lat();
                    var lng = results[0].geometry.location.lng();
                    g.$refs.QMap.map_center = { lat: lat, lng: lng }
                } else {
                    console.log("Geocode was not successful for the following reason: " + status);
                }
            })
        },
        getCurrentZipcode: function() {
            var g = this
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var lat = position.coords.latitude;
                    var long = position.coords.longitude;
                    var point = new g.google.maps.LatLng(lat, long);
                    g.map_center = point
                    new g.google.maps.Geocoder().geocode({ 'latLng': point },
                        function(res, status) {
                            var zip;
                            res[0].address_components.forEach(function(c) {
                                if (c.types.indexOf('postal_code') > -1) {
                                    zip = c.short_name
                                }
                            })
                            if (g.ZipCode == null || g.ZipCode == '') {
                                g.ZipCode = zip;
                                g.centerOnZipCode(zip);
                            }
                        }
                    );
                });
            }
        },
        savePharmacy: function(pharm) {
            //save to cookies
            var saved_pharmacies = Cookies.get('saved_pharmacies');
            if (typeof saved_pharmacies == 'undefined') {
                saved_pharmacies = []
            } else {
                saved_pharmacies = JSON.parse(Cookies.get('saved_pharmacies'));
            }
            pharm.DrugName = this.DrugName
            saved_pharmacies.push(pharm)
            Cookies.set('saved_pharmacies', JSON.stringify(saved_pharmacies), { path: '/', expires: 365, sameSite : 'None', secure : true });
            this.snackbar_text = "Prescription and pharmacy added!"
            this.snackbar = true
        }
    },
    computed: {
        'google': gmapApi
    },
    watch: {
        'ZipCode': function(newV) {
            if (newV == '' || newV == null) {
                return
            }
            if (newV.length >= 5) {
                Cookies.set('QuilityRxZipCode', newV, { path: '/' });
                this.centerOnZipCode(newV)
            }
        },
        'DrugName': function(newV) {
            this.$refs.QDrugLookup.setSearchWords(newV)
            if (this.ZipCode == null) {
                this.snackbar_text = "Please enter a zip code."
                this.snackbar = true
            }
        },
        'show_map': function(newV) {
            var g = this
            if (newV) {
                setTimeout(function() {
                    g.$refs.QMap.updateMap(g.Pharmacies)
                }, 250)
            }
        }
    },
    components: {
        QDrugLookup,
        QDrugComponents,
        QPopularDrugs,
        QMap,
        QAccessCode
    }
}
</script>
<style>
.q-price-lookup .pharmacy-panel .v-expansion-panel-header {
    display: flex;
    width: 100%;
    color: #000000;
}

.q-price-lookup .pharmacy-panel .v-expansion-panel-header>.price {
    font-size: 16px;
    font-weight: 500;
    flex-grow: 0;
    padding-right: 5px;
}

.q-price-lookup .v-expansion-panel-header>.pharmacy-name {
    font-size: 14px;
    flex-grow: 1;
}
</style>